export default __webpack_public_path__ + "static/media/animation_audio_dark.7680d737.gif";